import { EDealType } from '../types';
export var mapDealType = function mapDealType(dealType) {
  var dealTypes = {
    rent: EDealType.Rent,
    sale: EDealType.Sale
  };
  return dealTypes[dealType];
};